var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
var TransferInFilters = function (_a) {
    var filtersData = _a.filtersData, handleFilterChangeCallback = _a.handleFilterChangeCallback, handleApplyCallback = _a.handleApplyCallback, handleCancelCallback = _a.handleCancelCallback, handleClearAllCallback = _a.handleClearAllCallback, handleTabChange = _a.handleTabChange, activeFilter = _a.activeFilter;
    var _b = __read(React.useState(activeFilter || {}), 2), selectedStatusFilters = _b[0], setSelectedStatusFilters = _b[1];
    var generateStatusFilterTabContent = function () {
        var _a;
        return (React.createElement("div", { className: "d-flex flex-column order-status-checkbox-filters-container" },
            React.createElement("div", null, (_a = filtersData === null || filtersData === void 0 ? void 0 : filtersData.orderBookStatus) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                return (React.createElement(GenericCheckbox, { key: item.value, checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: (_a = selectedStatusFilters === null || selectedStatusFilters === void 0 ? void 0 : selectedStatusFilters.orderBookStatus) === null || _a === void 0 ? void 0 : _a.some(function (status) { return status.value === item.value; }),
                        value: item.value,
                        onChange: function () { return handleStatusChange("orderBookStatus", item); },
                    }, labelProps: {
                        children: item.name,
                        className: "DMsanL_12_300",
                    } }));
            }))));
    };
    var transferInFilterTabs = [
        {
            eventKey: "order_status",
            title: "Order Status",
            tabContent: generateStatusFilterTabContent(),
        },
    ];
    var handleStatusChange = function (key, filterItem) {
        setSelectedStatusFilters(function (prev) {
            var _a;
            var prevState = prev || {};
            var existingValues = prevState[key] || [];
            var exists = existingValues.some(function (v) { return v.value === filterItem.value; });
            var updatedValues = exists
                ? existingValues.filter(function (v) { return v.value !== filterItem.value; })
                : __spreadArray(__spreadArray([], __read(existingValues), false), [filterItem], false);
            return __assign(__assign({}, prevState), (_a = {}, _a[key] = updatedValues, _a));
        });
        if (handleFilterChangeCallback) {
            handleFilterChangeCallback(key, filterItem);
        }
    };
    var handleApply = function () {
        handleApplyCallback(selectedStatusFilters);
    };
    React.useEffect(function () {
        setSelectedStatusFilters(activeFilter || {});
    }, [activeFilter]);
    return (React.createElement(VerticalFilterTabs, { defaultActiveKey: "order_status", handleTabChange: handleTabChange, tabsList: transferInFilterTabs, cancelBtnCallback: handleCancelCallback, applyBtnCallback: handleApply, clearAllBtnCallback: handleClearAllCallback }));
};
export default TransferInFilters;
